import axios from 'axios';
import { API_URL } from '../utils/ApiLinks';
import { SocialSignIn} from '../types/SocialSignIn';
import { SocialSignUp } from '../types/SocialSignUp';
import { ProfileDto } from '../types/UserToken';

export const socialSignIn = async (email: string, idToken: string) => {
  try {
    
    const requestBody: SocialSignIn = { email, idToken };

    const response = await axios.post(`${API_URL}/Auth/social-signin`, 
      requestBody, 
      {
        headers: {
          'Content-Type': 'application/json',
        },
      }
    );
    return response.data;
  } catch (error: any) {
    handleAuthError(error);
    return undefined;
  }
};

export const signInWithEmail = async (email: string) => {
  try {
    const params = {
      email: email,
    };

    const response = await axios.post(`${API_URL}/Auth/email-signin`, params);

    return response.data;
    
  } catch (error) {
    handleAuthError(error);
    return undefined;
  }
};

export const verifyCode = async (email: string, code: string) => {
  try {
    const response = await axios.post(`${API_URL}/Auth/verify-otp`, {
      email,  
      otp: code  
    });

    return response.data; 
  } catch (error: any) {
    handleAuthError(error);  
    return undefined;
  }
};


export const completeSocialRegister = async (requestBody: SocialSignUp) => {
  try {
    const formData = new FormData();

    Object.entries(requestBody).forEach(([key, value]) => {
      if (key === "file" && value instanceof File) {
        formData.append(key, value);
      } else {
        formData.append(key, value as string); 
      }
    });

    const response = await axios.post(
      `${API_URL}/Auth/social-signup`,
      formData,
      {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      }
    );


    return response.data;
  } catch (error: any) {
    handleAuthError(error);
    return undefined;
  }
};

export const UserService = {
  searchUsernames: async (search: string) => {
    const res = await axios.get(`${API_URL}/user/search-usernames`, {
      params: { search },
    })
    return res.data as ProfileDto[]
  },

  searchUsersForChannels: async (search: string) => {
    const res = await axios.get(`${API_URL}/user/search-users-by-channels`, {
      params: { search },
    })
    return res.data as ProfileDto[]
  },
}

const handleAuthError = (error: any) => {
  if (error.response) {
    throw new Error(error.response.data || error.message);
  } else {
    throw new Error(error.message || 'An unknown error occurred');
  }
};
